import { List, ListItem } from '@cdl/heartbeat-react';
import { AutoLabel } from './AutoLabel';
import { Abnormality } from '../../diagnostic/types/diagnostic';

interface Props {
  abnormalities?: Abnormality[];
  labelColor?: string;
}

export const AutoLabelList: React.FC<Props> = ({
  labelColor,
  abnormalities,
}) => {
  if (!abnormalities || abnormalities.length === 0) {
    return null;
  }

  return (
    <List spacing='s'>
      {abnormalities.map(({ code, name }) => (
        <ListItem key={code}>
          <AutoLabel label={name} code={code} colorScheme={labelColor} />
        </ListItem>
      ))}
    </List>
  );
};
